import AddressbookStorageStore from '../flux/stores/addressbookStorageStore';
import AddressbookStorageActions from '../flux/actions/addressbookStorageActions';


class AddressbookSystemLoader {
	constructor() {
		this.initialized = false;
		this.onDataLoadedCallbacks = [];
		

		AddressbookStorageStore.listen(this.handleStoreChange.bind(this));
		

	}


	async init() {
		if (this.initialized) {

			return Promise.resolve();
		}


		
		try {

			await AddressbookStorageActions.loadAllAddressbooks();
			this.initialized = true;
			

			const data = this.getAddressbookData();
			this.onDataLoadedCallbacks.forEach(callback => {
				try {
					callback(data);
				} catch (err) {
					console.error('[AddressbookSystemLoader] Error in callback:', err);
				}
			});
			
			return Promise.resolve();
		} catch (error) {
			console.error('[AddressbookSystemLoader] Initialization failed:', error);
			return Promise.reject(error);
		}
	}

	handleStoreChange(state) {
		if (state.loading.allLoaded && !this.wasAllLoaded) {
			this.wasAllLoaded = true;
			
			const data = this.getAddressbookData();
			this.onDataLoadedCallbacks.forEach(callback => {
				try {
					callback(data);
				} catch (err) {
					console.error('[AddressbookSystemLoader] Error in store change callback:', err);
				}
			});
		}
	}


	onDataLoaded(callback) {
		if (typeof callback === 'function') {
			this.onDataLoadedCallbacks.push(callback);
		}
	}


	getAddressbookData() {
		const state = AddressbookStorageStore.getState();
		return {
			globalPersonal: state.globalPersonalAddressbook
		};
	}


	getAddressbookByType(type) {
		const state = AddressbookStorageStore.getState();
		if (type === 'globalPersonal') {
			return state.globalPersonalAddressbook;
		} else {
			return [];
		}
	}


	isLoading() {
		const state = AddressbookStorageStore.getState();
		return state.loading.globalPersonal;
	}


	isAllLoaded() {
		const state = AddressbookStorageStore.getState();
		return state.loading.allLoaded;
	}


	getStats() {
		const state = AddressbookStorageStore.getState();
		return state.stats;
	}


	getLogs() {
		const state = AddressbookStorageStore.getState();
		return state.logs;
	}


	getErrors() {
		const state = AddressbookStorageStore.getState();
		return state.errors;
	}


	async refresh() {
		try {
			await AddressbookStorageActions.refreshAllAddressbooks();
		} catch (error) {
			console.error('[AddressbookSystemLoader] Refresh failed:', error);
			throw error;
		}
	}


	logActivity(message) {
		AddressbookStorageActions.logActivity(message);
	}

	searchAll(searchTerm) {
		if (!searchTerm) return {};

		const lowerSearchTerm = searchTerm.toLowerCase();
		const data = this.getAddressbookData();
		const results = {};

		results.globalPersonal = data.globalPersonal.filter(entry => 
			(entry.name && entry.name.toLowerCase().includes(lowerSearchTerm)) ||
			(entry.address && entry.address.toLowerCase().includes(lowerSearchTerm))
		);

		return results;
	}


	getTotalCount() {
		const stats = this.getStats();
		return stats.totalGlobalPersonal;
	}

	findByAddress(address) {
		if (!address) return null;

		const data = this.getAddressbookData();
		const lowerAddress = address.toLowerCase();
		
		const found = data.globalPersonal.find(entry => 
			entry.address && entry.address.toLowerCase() === lowerAddress
		);
		
		return found ? { ...found, type: 'globalPersonal' } : null;
	}
}


const addressbookSystemLoader = new AddressbookSystemLoader();


export default addressbookSystemLoader; 